import NextImage from 'next/image'

import { Media } from '@/templates/Media/Media'

function Mobile({ src }: { src: string }) {
  const height = '50px'

  return (
    <Media
      className="flex justify-center overflow-hidden rounded-md"
      lessThan="lg"
    >
      <figure className="w-full">
        <NextImage
          alt={src}
          src={src}
          height={height}
          width="100%"
          layout="responsive"
          priority
          quality={75}
        />
      </figure>
    </Media>
  )
}

export default Mobile
